export const TABLE_CARD_WIDTH_CLASS = 'w-full max-w-[400px] sm:min-w-[min(370px,90vw)]';
export const TABLE_CARD_MIN_HEIGHT_CLASS = 'min-h-[348px]';
export const TABLE_CARD_SIZE_CLASS = `${TABLE_CARD_WIDTH_CLASS} ${TABLE_CARD_MIN_HEIGHT_CLASS} h-full`;
